module.exports = __webpack_public_path__ + "img/model-left.dc294347.png";